const dogbreeds = [
  {
    text: "option.breed-pedigree-dog.001",
    value: "Affenpinscher"
  },
  {
    text: "option.breed-pedigree-dog.002",
    value: "Afghan Hound"
  },
  {
    text: "option.breed-pedigree-dog.003",
    value: "Airedale Terrier"
  },
  {
    text: "option.breed-pedigree-dog.004",
    value: "Akita"
  },
  {
    text: "option.breed-pedigree-dog.005",
    value: "Alaskan Malamute"
  },
  {
    text: "option.breed-pedigree-dog.006",
    value: "Alpenländische Dachsbracke"
  },
  {
    text: "option.breed-pedigree-dog.007",
    value: "American Akita"
  },
  {
    text: "option.breed-pedigree-dog.008",
    value: "American Cocker Spaniel"
  },
  {
    text: "option.breed-pedigree-dog.009",
    value: "American Fox Hound"
  },
  {
    text: "option.breed-pedigree-dog.010",
    value: "American Hairless Terrier"
  },
  {
    text: "option.breed-pedigree-dog.011",
    value: "American Staffordshire Terrier"
  },
  {
    text: "option.breed-pedigree-dog.012",
    value: "American Toy Fox Terrier"
  },
  {
    text: "option.breed-pedigree-dog.013",
    value: "American Water Spaniel"
  },
  {
    text: "option.breed-pedigree-dog.014",
    value: "Anatolian Shepherd Dog"
  },
  {
    text: "option.breed-pedigree-dog.015",
    value: "Anglo-Russian Hound"
  },
  {
    text: "option.breed-pedigree-dog.016",
    value: "Appenzell Cattle Dog"
  },
  {
    text: "option.breed-pedigree-dog.017",
    value: "Australian Cattle Dog"
  },
  {
    text: "option.breed-pedigree-dog.018",
    value: "Australian Kelpie"
  },
  {
    text: "option.breed-pedigree-dog.019",
    value: "Australian Shepherd"
  },
  {
    text: "option.breed-pedigree-dog.020",
    value: "Australian Silky Terrier"
  },
  {
    text: "option.breed-pedigree-dog.021",
    value: "Australian Terrier"
  },
  {
    text: "option.breed-pedigree-dog.022",
    value: "Austrian Pinscher"
  },
  {
    text: "option.breed-pedigree-dog.023",
    value: "Azawakh"
  },
  {
    text: "option.breed-pedigree-dog.024",
    value: "Barbet"
  },
  {
    text: "option.breed-pedigree-dog.025",
    value: "Basenji"
  },
  {
    text: "option.breed-pedigree-dog.026",
    value: "Basset Artésien Normand"
  },
  {
    text: "option.breed-pedigree-dog.027",
    value: "Basset Bleu de Gascogne"
  },
  {
    text: "option.breed-pedigree-dog.028",
    value: "Basset fauve de Bretagne"
  },
  {
    text: "option.breed-pedigree-dog.029",
    value: "Basset Griffon Vendéen"
  },
  {
    text: "option.breed-pedigree-dog.030",
    value: "Basset Hound"
  },
  {
    text: "option.breed-pedigree-dog.031",
    value: "Bavarian Mountain Scenthound"
  },
  {
    text: "option.breed-pedigree-dog.032",
    value: "Beagle"
  },
  {
    text: "option.breed-pedigree-dog.033",
    value: "Beagle Harrier"
  },
  {
    text: "option.breed-pedigree-dog.034",
    value: "Bearded Collie"
  },
  {
    text: "option.breed-pedigree-dog.035",
    value: "Beauceron"
  },
  {
    text: "option.breed-pedigree-dog.036",
    value: "Bedlington Terrier"
  },
  {
    text: "option.breed-pedigree-dog.037",
    value: "Belgian Shepherd Dog, Groenendael"
  },
  {
    text: "option.breed-pedigree-dog.038",
    value: "Belgian Shepherd Dog, Laekenois"
  },
  {
    text: "option.breed-pedigree-dog.039",
    value: "Belgian Shepherd Dog, Malinois"
  },
  {
    text: "option.breed-pedigree-dog.040",
    value: "Belgian Shepherd Dog, Tervueren"
  },
  {
    text: "option.breed-pedigree-dog.041",
    value: "Belgian Shepherd Dogs"
  },
  {
    text: "option.breed-pedigree-dog.042",
    value: "Bergamasco"
  },
  {
    text: "option.breed-pedigree-dog.043",
    value: "Berger Picard"
  },
  {
    text: "option.breed-pedigree-dog.044",
    value: "Bernese Mountain Dog"
  },
  {
    text: "option.breed-pedigree-dog.045",
    value: "Bichon Frisé"
  },
  {
    text: "option.breed-pedigree-dog.046",
    value: "Bichon Havanais"
  },
  {
    text: "option.breed-pedigree-dog.047",
    value: "Black and Tan Coon Hound"
  },
  {
    text: "option.breed-pedigree-dog.048",
    value: "Black Russian Terrier"
  },
  {
    text: "option.breed-pedigree-dog.049",
    value: "Blood Hound"
  },
  {
    text: "option.breed-pedigree-dog.050",
    value: "Blue Picardy Spaniel"
  },
  {
    text: "option.breed-pedigree-dog.051",
    value: "Bolognese"
  },
  {
    text: "option.breed-pedigree-dog.052",
    value: "Border Collie"
  },
  {
    text: "option.breed-pedigree-dog.053",
    value: "Border Terrier"
  },
  {
    text: "option.breed-pedigree-dog.054",
    value: "Borzoi"
  },
  {
    text: "option.breed-pedigree-dog.055",
    value: "Boston Terrier"
  },
  {
    text: "option.breed-pedigree-dog.056",
    value: "Bouvier des Flandres"
  },
  {
    text: "option.breed-pedigree-dog.057",
    value: "Boxer"
  },
  {
    text: "option.breed-pedigree-dog.058",
    value: "Bracco Italiano"
  },
  {
    text: "option.breed-pedigree-dog.059",
    value: "Braque d'Auvergne"
  },
  {
    text: "option.breed-pedigree-dog.060",
    value: "Braque du Bourbonnais"
  },
  {
    text: "option.breed-pedigree-dog.061",
    value: "Braque Francais, type Pyrenees"
  },
  {
    text: "option.breed-pedigree-dog.062",
    value: "Brazilian Terrier"
  },
  {
    text: "option.breed-pedigree-dog.063",
    value: "Briard"
  },
  {
    text: "option.breed-pedigree-dog.064",
    value: "Brittany"
  },
  {
    text: "option.breed-pedigree-dog.065",
    value: "Broholmer"
  },
  {
    text: "option.breed-pedigree-dog.066",
    value: "Bull Terrier"
  },
  {
    text: "option.breed-pedigree-dog.067",
    value: "Bulldog"
  },
  {
    text: "option.breed-pedigree-dog.068",
    value: "Bullmastiff"
  },
  {
    text: "option.breed-pedigree-dog.069",
    value: "Burgos Pointing Dog"
  },
  {
    text: "option.breed-pedigree-dog.070",
    value: "Cairn Terrier"
  },
  {
    text: "option.breed-pedigree-dog.071",
    value: "Canaan Dog"
  },
  {
    text: "option.breed-pedigree-dog.072",
    value: "Cao Fila de Sao Miguel"
  },
  {
    text: "option.breed-pedigree-dog.073",
    value: "Catalan Sheepdog"
  },
  {
    text: "option.breed-pedigree-dog.074",
    value: "Caucasian Ovtcharka"
  },
  {
    text: "option.breed-pedigree-dog.075",
    value: "Cavalier King Charles Spaniel"
  },
  {
    text: "option.breed-pedigree-dog.076",
    value: "Central Asian Ovtcharka"
  },
  {
    text: "option.breed-pedigree-dog.077",
    value: "Ceskoslovensky Vlcak"
  },
  {
    text: "option.breed-pedigree-dog.078",
    value: "Cesky Fousek"
  },
  {
    text: "option.breed-pedigree-dog.079",
    value: "Cesky Terrier"
  },
  {
    text: "option.breed-pedigree-dog.080",
    value: "Chesapeake Bay Retriever"
  },
  {
    text: "option.breed-pedigree-dog.081",
    value: "Chihuahua"
  },
  {
    text: "option.breed-pedigree-dog.082",
    value: "Chihuahua Long-haired"
  },
  {
    text: "option.breed-pedigree-dog.083",
    value: "Chihuahua Smooth-haired"
  },
  {
    text: "option.breed-pedigree-dog.084",
    value: "Chinese Crested Dog"
  },
  {
    text: "option.breed-pedigree-dog.085",
    value: "Chinese Crested Dog, Powder Puff"
  },
  {
    text: "option.breed-pedigree-dog.086",
    value: "Chodsky Pes"
  },
  {
    text: "option.breed-pedigree-dog.087",
    value: "Chow Chow"
  },
  {
    text: "option.breed-pedigree-dog.088",
    value: "Chow Chow, Smooth-haired"
  },
  {
    text: "option.breed-pedigree-dog.089",
    value: "Cirneco dell'Etna"
  },
  {
    text: "option.breed-pedigree-dog.090",
    value: "Clumber Spaniel"
  },
  {
    text: "option.breed-pedigree-dog.091",
    value: "Coarse-haired Istrian Hound"
  },
  {
    text: "option.breed-pedigree-dog.092",
    value: "Coarse-haired Italian Hound"
  },
  {
    text: "option.breed-pedigree-dog.093",
    value: "Cocker Spaniel"
  },
  {
    text: "option.breed-pedigree-dog.094",
    value: "Collie"
  },
  {
    text: "option.breed-pedigree-dog.095",
    value: "Collie Rough"
  },
  {
    text: "option.breed-pedigree-dog.096",
    value: "Collie Smooth"
  },
  {
    text: "option.breed-pedigree-dog.097",
    value: "Coton de Tuléar"
  },
  {
    text: "option.breed-pedigree-dog.098",
    value: "Croatian Sheepdog"
  },
  {
    text: "option.breed-pedigree-dog.099",
    value: "Curly Coated Retriever"
  },
  {
    text: "option.breed-pedigree-dog.100",
    value: "Dachshund"
  },
  {
    text: "option.breed-pedigree-dog.101",
    value: "Dachshund, Miniature Long-haired"
  },
  {
    text: "option.breed-pedigree-dog.102",
    value: "Dachshund, Miniature Smooth-haired"
  },
  {
    text: "option.breed-pedigree-dog.103",
    value: "Dachshund, Miniature Wire-haired"
  },
  {
    text: "option.breed-pedigree-dog.104",
    value: "Dachshund, Standard Long-haired"
  },
  {
    text: "option.breed-pedigree-dog.105",
    value: "Dachshund, Standard Smooth-haired"
  },
  {
    text: "option.breed-pedigree-dog.106",
    value: "Dachshund, Standard Wire-haired"
  },
  {
    text: "option.breed-pedigree-dog.107",
    value: "Dalmatian"
  },
  {
    text: "option.breed-pedigree-dog.108",
    value: "Dandie Dinmont Terrier"
  },
  {
    text: "option.breed-pedigree-dog.109",
    value: "Danish-Swedish Farmdog"
  },
  {
    text: "option.breed-pedigree-dog.110",
    value: "Deerhound"
  },
  {
    text: "option.breed-pedigree-dog.111",
    value: "Dobermann"
  },
  {
    text: "option.breed-pedigree-dog.112",
    value: "Dogo Argentino"
  },
  {
    text: "option.breed-pedigree-dog.113",
    value: "Dogo Canario"
  },
  {
    text: "option.breed-pedigree-dog.114",
    value: "Dogo Mallorquin"
  },
  {
    text: "option.breed-pedigree-dog.115",
    value: "Dogue de Bordeaux"
  },
  {
    text: "option.breed-pedigree-dog.116",
    value: "Drever"
  },
  {
    text: "option.breed-pedigree-dog.117",
    value: "Dunker Hound"
  },
  {
    text: "option.breed-pedigree-dog.118",
    value: "Dutch Shepherd Dog, Long-haired"
  },
  {
    text: "option.breed-pedigree-dog.119",
    value: "Dutch Shepherd Dog, Rough-Haired"
  },
  {
    text: "option.breed-pedigree-dog.120",
    value: "Dutch Shepherd Dog, Short-haired"
  },
  {
    text: "option.breed-pedigree-dog.121",
    value: "Dutch Shepherd Dogs"
  },
  {
    text: "option.breed-pedigree-dog.122",
    value: "East-Siberian Laika"
  },
  {
    text: "option.breed-pedigree-dog.123",
    value: "English Foxhound"
  },
  {
    text: "option.breed-pedigree-dog.124",
    value: "English Pointer"
  },
  {
    text: "option.breed-pedigree-dog.125",
    value: "English Setter"
  },
  {
    text: "option.breed-pedigree-dog.126",
    value: "English Springer Spaniel"
  },
  {
    text: "option.breed-pedigree-dog.127",
    value: "English Toy Terrier"
  },
  {
    text: "option.breed-pedigree-dog.128",
    value: "Entlebuch Cattle Dog"
  },
  {
    text: "option.breed-pedigree-dog.129",
    value: "Estonian Hound"
  },
  {
    text: "option.breed-pedigree-dog.130",
    value: "Estrela Mountain Dogs"
  },
  {
    text: "option.breed-pedigree-dog.131",
    value: "Eurasier"
  },
  {
    text: "option.breed-pedigree-dog.132",
    value: "Field Spaniel"
  },
  {
    text: "option.breed-pedigree-dog.133",
    value: "Fila Brasileiro"
  },
  {
    text: "option.breed-pedigree-dog.134",
    value: "Finnish Hound"
  },
  {
    text: "option.breed-pedigree-dog.135",
    value: "Finnish Lapphund"
  },
  {
    text: "option.breed-pedigree-dog.136",
    value: "Finnish Spitz"
  },
  {
    text: "option.breed-pedigree-dog.137",
    value: "Flat Coated Retriever"
  },
  {
    text: "option.breed-pedigree-dog.138",
    value: "Fox Terrier, Smooth-haired"
  },
  {
    text: "option.breed-pedigree-dog.139",
    value: "Fox Terrier, Wire-haired"
  },
  {
    text: "option.breed-pedigree-dog.140",
    value: "French Bulldog"
  },
  {
    text: "option.breed-pedigree-dog.141",
    value: "French Spaniel1"
  },
  {
    text: "option.breed-pedigree-dog.142",
    value: "French Spaniel"
  },
  {
    text: "option.breed-pedigree-dog.143",
    value: "French Wire-haired Korthals Pointing Dog"
  },
  {
    text: "option.breed-pedigree-dog.144",
    value: "German Hound"
  },
  {
    text: "option.breed-pedigree-dog.145",
    value: "German Hunting Terrier"
  },
  {
    text: "option.breed-pedigree-dog.146",
    value: "German Pinscher"
  },
  {
    text: "option.breed-pedigree-dog.147",
    value: "German Shepherd Dog"
  },
  {
    text: "option.breed-pedigree-dog.148",
    value: "German Shepherd Dog, long and harsh outer coat"
  },
  {
    text: "option.breed-pedigree-dog.149",
    value: "German Spaniel"
  },
  {
    text: "option.breed-pedigree-dog.150",
    value: "Giant Schnauzers"
  },
  {
    text: "option.breed-pedigree-dog.151",
    value: "Golden Retriever"
  },
  {
    text: "option.breed-pedigree-dog.152",
    value: "Gordon Setter"
  },
  {
    text: "option.breed-pedigree-dog.153",
    value: "Grand Basset Griffon Vendéen"
  },
  {
    text: "option.breed-pedigree-dog.154",
    value: "Grand Bleu de Gascogne"
  },
  {
    text: "option.breed-pedigree-dog.155",
    value: "Great Dane"
  },
  {
    text: "option.breed-pedigree-dog.156",
    value: "Great Swiss Cattle Dog"
  },
  {
    text: "option.breed-pedigree-dog.157",
    value: "Greenland Dog"
  },
  {
    text: "option.breed-pedigree-dog.158",
    value: "Greyhound"
  },
  {
    text: "option.breed-pedigree-dog.159",
    value: "Griffon Belge"
  },
  {
    text: "option.breed-pedigree-dog.160",
    value: "Griffon Bruxellois"
  },
  {
    text: "option.breed-pedigree-dog.161",
    value: "Griffon Fauve de Bretagne"
  },
  {
    text: "option.breed-pedigree-dog.162",
    value: "Grosspitz"
  },
  {
    text: "option.breed-pedigree-dog.163",
    value: "Halden Hound"
  },
  {
    text: "option.breed-pedigree-dog.164",
    value: "Hamilton Hound"
  },
  {
    text: "option.breed-pedigree-dog.165",
    value: "Hanoverian Scenthound"
  },
  {
    text: "option.breed-pedigree-dog.166",
    value: "Harrier"
  },
  {
    text: "option.breed-pedigree-dog.167",
    value: "Hellenic Hound"
  },
  {
    text: "option.breed-pedigree-dog.168",
    value: "Hokkaido"
  },
  {
    text: "option.breed-pedigree-dog.169",
    value: "Hollandse Smoushond"
  },
  {
    text: "option.breed-pedigree-dog.170",
    value: "Hovawart"
  },
  {
    text: "option.breed-pedigree-dog.171",
    value: "Hungarian Greyhound"
  },
  {
    text: "option.breed-pedigree-dog.172",
    value: "Hungarian Vizsla"
  },
  {
    text: "option.breed-pedigree-dog.173",
    value: "Hygen Hound"
  },
  {
    text: "option.breed-pedigree-dog.174",
    value: "Hälleforshund"
  },
  {
    text: "option.breed-pedigree-dog.175",
    value: "Ibizan Hounds"
  },
  {
    text: "option.breed-pedigree-dog.176",
    value: "Iceland Sheepdog"
  },
  {
    text: "option.breed-pedigree-dog.177",
    value: "Irish Glen Of Imaal Terrier"
  },
  {
    text: "option.breed-pedigree-dog.178",
    value: "Irish Red and White Setter"
  },
  {
    text: "option.breed-pedigree-dog.179",
    value: "Irish Red Setter"
  },
  {
    text: "option.breed-pedigree-dog.180",
    value: "Irish Soft Coated Wheaten Terrier"
  },
  {
    text: "option.breed-pedigree-dog.181",
    value: "Irish Terrier"
  },
  {
    text: "option.breed-pedigree-dog.182",
    value: "Irish Water Spaniel"
  },
  {
    text: "option.breed-pedigree-dog.183",
    value: "Irish Wolfhound"
  },
  {
    text: "option.breed-pedigree-dog.184",
    value: "Italian Cane Corso"
  },
  {
    text: "option.breed-pedigree-dog.185",
    value: "Italian Greyhound"
  },
  {
    text: "option.breed-pedigree-dog.186",
    value: "Jack Russell Terrier"
  },
  {
    text: "option.breed-pedigree-dog.187",
    value: "Japanese Chin"
  },
  {
    text: "option.breed-pedigree-dog.188",
    value: "Japanese Spitz"
  },
  {
    text: "option.breed-pedigree-dog.189",
    value: "Kai"
  },
  {
    text: "option.breed-pedigree-dog.190",
    value: "Karelian Bear Dog"
  },
  {
    text: "option.breed-pedigree-dog.191",
    value: "Keeshond"
  },
  {
    text: "option.breed-pedigree-dog.192",
    value: "Kerry Blue Terrier"
  },
  {
    text: "option.breed-pedigree-dog.193",
    value: "King Charles Spaniel"
  },
  {
    text: "option.breed-pedigree-dog.194",
    value: "Kishu"
  },
  {
    text: "option.breed-pedigree-dog.195",
    value: "Kleinspitz"
  },
  {
    text: "option.breed-pedigree-dog.196",
    value: "Komondor"
  },
  {
    text: "option.breed-pedigree-dog.197",
    value: "Kopo"
  },
  {
    text: "option.breed-pedigree-dog.198",
    value: "Kromfohrländer"
  },
  {
    text: "option.breed-pedigree-dog.199",
    value: "Kuvasz"
  },
  {
    text: "option.breed-pedigree-dog.200",
    value: "Labrador Retriever"
  },
  {
    text: "option.breed-pedigree-dog.201",
    value: "Lagotto Romagnolo"
  },
  {
    text: "option.breed-pedigree-dog.202",
    value: "Lakeland Terrier"
  },
  {
    text: "option.breed-pedigree-dog.203",
    value: "Lancashire Heeler"
  },
  {
    text: "option.breed-pedigree-dog.204",
    value: "Landseer"
  },
  {
    text: "option.breed-pedigree-dog.205",
    value: "Lapponian Herder"
  },
  {
    text: "option.breed-pedigree-dog.206",
    value: "Large Münsterländer"
  },
  {
    text: "option.breed-pedigree-dog.207",
    value: "Leonberger"
  },
  {
    text: "option.breed-pedigree-dog.208",
    value: "Lhasa Apso"
  },
  {
    text: "option.breed-pedigree-dog.209",
    value: "Little Lion Dog"
  },
  {
    text: "option.breed-pedigree-dog.210",
    value: "Long-haired German Pointer"
  },
  {
    text: "option.breed-pedigree-dog.211",
    value: "Long-haired Pyrenean Sheepdog"
  },
  {
    text: "option.breed-pedigree-dog.212",
    value: "Maltese"
  },
  {
    text: "option.breed-pedigree-dog.213",
    value: "Manchester Terrier"
  },
  {
    text: "option.breed-pedigree-dog.214",
    value: "Maremma and Abruzzese Sheepdog"
  },
  {
    text: "option.breed-pedigree-dog.215",
    value: "Mastiff"
  },
  {
    text: "option.breed-pedigree-dog.216",
    value: "Medium Size Poodle"
  },
  {
    text: "option.breed-pedigree-dog.217",
    value: "Mexican Hairless Dogs"
  },
  {
    text: "option.breed-pedigree-dog.218",
    value: "Miniature Bull Terrier"
  },
  {
    text: "option.breed-pedigree-dog.219",
    value: "Miniature Pinscher"
  },
  {
    text: "option.breed-pedigree-dog.220",
    value: "Miniature Poodle"
  },
  {
    text: "option.breed-pedigree-dog.221",
    value: "Miniature Schnauzers"
  },
  {
    text: "option.breed-pedigree-dog.222",
    value: "Mittelspitz"
  },
  {
    text: "option.breed-pedigree-dog.223",
    value: "Mudi"
  },
  {
    text: "option.breed-pedigree-dog.224",
    value: "Napolitan Mastiff"
  },
  {
    text: "option.breed-pedigree-dog.225",
    value: "Nederlandse Kooikerhondje"
  },
  {
    text: "option.breed-pedigree-dog.226",
    value: "Newfoundland"
  },
  {
    text: "option.breed-pedigree-dog.227",
    value: "Norfolk Terrier"
  },
  {
    text: "option.breed-pedigree-dog.228",
    value: "Norrbottenspitz"
  },
  {
    text: "option.breed-pedigree-dog.229",
    value: "Norwegian Buhund"
  },
  {
    text: "option.breed-pedigree-dog.230",
    value: "Norwegian Elkhound, black"
  },
  {
    text: "option.breed-pedigree-dog.231",
    value: "Norwegian Elkhound, grey"
  },
  {
    text: "option.breed-pedigree-dog.232",
    value: "Norwegian Lundehund"
  },
  {
    text: "option.breed-pedigree-dog.233",
    value: "Norwich Terrier"
  },
  {
    text: "option.breed-pedigree-dog.234",
    value: "Nova Scotia Duck Tolling Retriever"
  },
  {
    text: "option.breed-pedigree-dog.235",
    value: "Old Danish Pointer"
  },
  {
    text: "option.breed-pedigree-dog.236",
    value: "Old English Sheepdog"
  },
  {
    text: "option.breed-pedigree-dog.237",
    value: "Olde English Bulldogge"
  },
  {
    text: "option.breed-pedigree-dog.238",
    value: "Otterhound"
  },
  {
    text: "option.breed-pedigree-dog.239",
    value: "Papillon"
  },
  {
    text: "option.breed-pedigree-dog.240",
    value: "Parson Russell Terrier"
  },
  {
    text: "option.breed-pedigree-dog.241",
    value: "Pekingese"
  },
  {
    text: "option.breed-pedigree-dog.242",
    value: "Peruvian Hairless Dog"
  },
  {
    text: "option.breed-pedigree-dog.243",
    value: "Petit Basset Griffon Vendéen"
  },
  {
    text: "option.breed-pedigree-dog.244",
    value: "Petit Bleu de Gascogne"
  },
  {
    text: "option.breed-pedigree-dog.245",
    value: "Petit Brabancon"
  },
  {
    text: "option.breed-pedigree-dog.246",
    value: "Phalène"
  },
  {
    text: "option.breed-pedigree-dog.247",
    value: "Pharaoh Hound"
  },
  {
    text: "option.breed-pedigree-dog.248",
    value: "Picardy Spaniel"
  },
  {
    text: "option.breed-pedigree-dog.249",
    value: "Plott"
  },
  {
    text: "option.breed-pedigree-dog.250",
    value: "Podengo Portuguese Smooth-haired Large"
  },
  {
    text: "option.breed-pedigree-dog.251",
    value: "Podengo Portuguese Smooth-haired Medium size"
  },
  {
    text: "option.breed-pedigree-dog.252",
    value: "Podengo Portuguese Smooth-haired Miniature"
  },
  {
    text: "option.breed-pedigree-dog.253",
    value: "Podengo Portuguese Wire-haired Miniature"
  },
  {
    text: "option.breed-pedigree-dog.254",
    value: "Podengo Portuguese, Wire-haired Medium size"
  },
  {
    text: "option.breed-pedigree-dog.255",
    value: "Polish Greyhound"
  },
  {
    text: "option.breed-pedigree-dog.256",
    value: "Polish Hound"
  },
  {
    text: "option.breed-pedigree-dog.257",
    value: "Polish Lowland Sheepdog"
  },
  {
    text: "option.breed-pedigree-dog.258",
    value: "Pomeranian"
  },
  {
    text: "option.breed-pedigree-dog.259",
    value: "Poodles"
  },
  {
    text: "option.breed-pedigree-dog.260",
    value: "Porcelaine"
  },
  {
    text: "option.breed-pedigree-dog.261",
    value: "Portuguese Pointing Dog"
  },
  {
    text: "option.breed-pedigree-dog.262",
    value: "Portuguese Sheepdog"
  },
  {
    text: "option.breed-pedigree-dog.263",
    value: "Portuguese Water Dog"
  },
  {
    text: "option.breed-pedigree-dog.264",
    value: "Posavski Gonic"
  },
  {
    text: "option.breed-pedigree-dog.265",
    value: "Pražský Krysarík"
  },
  {
    text: "option.breed-pedigree-dog.266",
    value: "Pudelpointer"
  },
  {
    text: "option.breed-pedigree-dog.267",
    value: "Pug"
  },
  {
    text: "option.breed-pedigree-dog.268",
    value: "Puli"
  },
  {
    text: "option.breed-pedigree-dog.269",
    value: "Pumi"
  },
  {
    text: "option.breed-pedigree-dog.270",
    value: "Pyrenean Mastiff"
  },
  {
    text: "option.breed-pedigree-dog.271",
    value: "Pyrenean Mountain Dog"
  },
  {
    text: "option.breed-pedigree-dog.272",
    value: "Rabbit Dachshund, Long-haired"
  },
  {
    text: "option.breed-pedigree-dog.273",
    value: "Rabbit Dachshund, Smooth-haired"
  },
  {
    text: "option.breed-pedigree-dog.274",
    value: "Rabbit Dachshund, Wire-haired"
  },
  {
    text: "option.breed-pedigree-dog.275",
    value: "Rhodesian Ridgeback"
  },
  {
    text: "option.breed-pedigree-dog.276",
    value: "Romanian Mioritic Shepherd Dog"
  },
  {
    text: "option.breed-pedigree-dog.277",
    value: "Rottweiler"
  },
  {
    text: "option.breed-pedigree-dog.278",
    value: "Russian Hound"
  },
  {
    text: "option.breed-pedigree-dog.279",
    value: "Russian Toy"
  },
  {
    text: "option.breed-pedigree-dog.280",
    value: "Russian-European Laika"
  },
  {
    text: "option.breed-pedigree-dog.281",
    value: "Russkaja Tsvetnaja Bolonka"
  },
  {
    text: "option.breed-pedigree-dog.282",
    value: "Saarloos Wolfdog"
  },
  {
    text: "option.breed-pedigree-dog.283",
    value: "Saint Bernard"
  },
  {
    text: "option.breed-pedigree-dog.284",
    value: "Saint Bernard Dog, Long-haired"
  },
  {
    text: "option.breed-pedigree-dog.285",
    value: "Saint Bernard Dog, Short-haired"
  },
  {
    text: "option.breed-pedigree-dog.286",
    value: "Saluki"
  },
  {
    text: "option.breed-pedigree-dog.287",
    value: "Samoyed"
  },
  {
    text: "option.breed-pedigree-dog.288",
    value: "Sarplaninac"
  },
  {
    text: "option.breed-pedigree-dog.289",
    value: "Sauerland Hound"
  },
  {
    text: "option.breed-pedigree-dog.290",
    value: "Schapendoes"
  },
  {
    text: "option.breed-pedigree-dog.291",
    value: "Schiller Hound"
  },
  {
    text: "option.breed-pedigree-dog.292",
    value: "Schipperke"
  },
  {
    text: "option.breed-pedigree-dog.293",
    value: "Schnauzers"
  },
  {
    text: "option.breed-pedigree-dog.294",
    value: "Scottish Terrier"
  },
  {
    text: "option.breed-pedigree-dog.295",
    value: "Sealyham Terrier"
  },
  {
    text: "option.breed-pedigree-dog.296",
    value: "Shar Pei"
  },
  {
    text: "option.breed-pedigree-dog.297",
    value: "Shetland Sheepdog"
  },
  {
    text: "option.breed-pedigree-dog.298",
    value: "Shiba"
  },
  {
    text: "option.breed-pedigree-dog.299",
    value: "Shih Tzu"
  },
  {
    text: "option.breed-pedigree-dog.300",
    value: "Shikoku"
  },
  {
    text: "option.breed-pedigree-dog.301",
    value: "Short-haired German Pointer"
  },
  {
    text: "option.breed-pedigree-dog.302",
    value: "Short-haired Italian Hound"
  },
  {
    text: "option.breed-pedigree-dog.303",
    value: "Short-haired Pyrenean Sheepdog"
  },
  {
    text: "option.breed-pedigree-dog.304",
    value: "Siberian Husky"
  },
  {
    text: "option.breed-pedigree-dog.305",
    value: "Skye Terrier"
  },
  {
    text: "option.breed-pedigree-dog.306",
    value: "Sloughi"
  },
  {
    text: "option.breed-pedigree-dog.307",
    value: "Slovakian Chuvach"
  },
  {
    text: "option.breed-pedigree-dog.308",
    value: "Slovakian Hound"
  },
  {
    text: "option.breed-pedigree-dog.309",
    value: "Small Münsterländer"
  },
  {
    text: "option.breed-pedigree-dog.310",
    value: "South-Russian Ovtcharka"
  },
  {
    text: "option.breed-pedigree-dog.311",
    value: "Spaniel de Pont-Audemer"
  },
  {
    text: "option.breed-pedigree-dog.312",
    value: "Spanish Greyhound"
  },
  {
    text: "option.breed-pedigree-dog.313",
    value: "Spanish Mastiff"
  },
  {
    text: "option.breed-pedigree-dog.314",
    value: "Spanish Waterdog"
  },
  {
    text: "option.breed-pedigree-dog.315",
    value: "Spinone Italiano"
  },
  {
    text: "option.breed-pedigree-dog.316",
    value: "Stabyhoun"
  },
  {
    text: "option.breed-pedigree-dog.317",
    value: "Staffordshire Bull Terrier"
  },
  {
    text: "option.breed-pedigree-dog.318",
    value: "Standard Poodle"
  },
  {
    text: "option.breed-pedigree-dog.319",
    value: "Sussex Spaniel"
  },
  {
    text: "option.breed-pedigree-dog.320",
    value: "Swedish Elkhound"
  },
  {
    text: "option.breed-pedigree-dog.321",
    value: "Swedish Lapphund"
  },
  {
    text: "option.breed-pedigree-dog.322",
    value: "Swedish Vallhund"
  },
  {
    text: "option.breed-pedigree-dog.323",
    value: "Swedish White Elkhound"
  },
  {
    text: "option.breed-pedigree-dog.324",
    value: "Swiss Hound"
  },
  {
    text: "option.breed-pedigree-dog.325",
    value: "Swiss Hound, Lucerne Hound"
  },
  {
    text: "option.breed-pedigree-dog.326",
    value: "Tatra Shepherd Dog"
  },
  {
    text: "option.breed-pedigree-dog.327",
    value: "Thai Ridgeback"
  },
  {
    text: "option.breed-pedigree-dog.328",
    value: "Tibetan Mastiff"
  },
  {
    text: "option.breed-pedigree-dog.329",
    value: "Tibetan Spaniel"
  },
  {
    text: "option.breed-pedigree-dog.330",
    value: "Tibetan Terrier"
  },
  {
    text: "option.breed-pedigree-dog.331",
    value: "Tornjak"
  },
  {
    text: "option.breed-pedigree-dog.332",
    value: "Tosa"
  },
  {
    text: "option.breed-pedigree-dog.333",
    value: "Toy Poodle"
  },
  {
    text: "option.breed-pedigree-dog.334",
    value: "Uruguayan Cimarron"
  },
  {
    text: "option.breed-pedigree-dog.335",
    value: "Volpino Italiano"
  },
  {
    text: "option.breed-pedigree-dog.336",
    value: "Weimaraner"
  },
  {
    text: "option.breed-pedigree-dog.337",
    value: "Welsh Corgi"
  },
  {
    text: "option.breed-pedigree-dog.338",
    value: "Welsh Corgi Cardigan"
  },
  {
    text: "option.breed-pedigree-dog.339",
    value: "Welsh Corgi Pembroke"
  },
  {
    text: "option.breed-pedigree-dog.340",
    value: "Welsh Springer Spaniel"
  },
  {
    text: "option.breed-pedigree-dog.341",
    value: "Welsh Terrier"
  },
  {
    text: "option.breed-pedigree-dog.342",
    value: "West Highland White Terrier"
  },
  {
    text: "option.breed-pedigree-dog.343",
    value: "West-Siberian Laika"
  },
  {
    text: "option.breed-pedigree-dog.344",
    value: "Wetterhoun"
  },
  {
    text: "option.breed-pedigree-dog.345",
    value: "Whippet"
  },
  {
    text: "option.breed-pedigree-dog.346",
    value: "White Swiss Shepherd Dog"
  },
  {
    text: "option.breed-pedigree-dog.347",
    value: "Wire-haired German Pointer"
  },
  {
    text: "option.breed-pedigree-dog.348",
    value: "Yorkshire Terrier"
  },
  {
    text: "option.breed-pedigree-dog.349",
    value: "Breed unknown"
  }
]
export default dogbreeds
